import { Pipe, PipeTransform } from '@angular/core';

import { EventOption } from '@frontend/sports/betting-offer/feature/model';

@Pipe({ name: 'msCorrectScoreOptionName' })
export class CorrectScoreOptionPipe implements PipeTransform {
    transform(option: EventOption): string | undefined {
        if (option.player1Score == null || option.player2Score == null) {
            return option.name;
        }

        return `${option.player1Score}-${option.player2Score}`;
    }
}
